var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "login-fade" }, [
    _c("div", { staticClass: "login" }, [
      _c(
        "button",
        { staticClass: "login-close", on: { click: _vm.inviteClose } },
        [
          _c(
            "svg",
            {
              attrs: {
                width: "23",
                height: "23",
                viewBox: "0 0 23 23",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M2.00342 2L20.6685 20.6651",
                  stroke: "black",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M20.665 2L1.99993 20.6651",
                  stroke: "black",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                },
              }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "login-form" }, [
        _c("p", { staticClass: "login-title" }, [
          _vm._v("Invite your friends!"),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "login-subtitle" }, [
          _vm._v(
            "\n        " +
              _vm._s(this.currentUser.full_name) +
              " has invited you to Pixchange!\n      "
          ),
        ]),
        _vm._v(" "),
        _c("img", {
          staticClass: "invite-image",
          attrs: {
            src: require("../../../../public/img/invitation.png"),
            width: "193",
            height: "193",
            loading: "lazy",
            alt: "invitation",
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "invitation-bottom" }, [
          _c("input", {
            ref: "inviteInput",
            staticClass: "invite-link",
            attrs: { type: "text", readonly: "" },
            domProps: { value: _vm.inviteLink },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "copy-link-wrapper" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.copyLink,
                    expression: "copyLink",
                  },
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.copyLinkClose,
                    expression: "copyLinkClose",
                  },
                ],
                staticClass: "copy-link",
              },
              [_vm._m(0)]
            ),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "invite-copy", on: { click: _vm.copyLinkClick } },
              [_vm._v("\n            Copy link\n          ")]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "copy-link-inner" }, [
      _c("p", { staticClass: "copy-title" }, [
        _vm._v("\n                Copied to clipboard!\n              "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }